<template>
  <v-app v-if="breakpoint.lgUp" class="auth-layout h-screen">
    <div class="auth-layout__split">
      <RouterLink class="auth-layout__brand" to="/" aria-label="Visit homepage">
        <img width="400" alt="Profit Tracking" src="/logo_dark.svg" />
      </RouterLink>
      <main class="auth-layout__form">
        <RouterView />
      </main>
    </div>
  </v-app>

  <v-app v-else class="auth-layout h-screen">
    <main class="auth-layout__mobile p-4">
      <RouterLink class="py-4 inline-block" to="/" aria-label="Visit homepage">
        <img width="200" alt="Profit Tracking" src="/logo.svg" />
      </RouterLink>
      <RouterView />
    </main>
  </v-app>
</template>

<script lang="ts" setup>
import { useAppDisplay } from '@/composables/ui/useAppDisplay'

const breakpoint = useAppDisplay()
</script>

<style scoped>
.auth-layout {
  background-color: rgb(var(--v-theme-background-secondary));
}

.auth-layout__split {
  display: grid;
  grid-template-columns: 35vw 1fr;
  min-height: 100vh;
}

.auth-layout__brand {
  background-color: rgb(var(--v-theme-primary));
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.auth-layout__form {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.auth-layout__form > * {
  width: 100%;
  max-width: 420px;
}

.auth-layout__mobile {
  max-width: 420px;
  margin: 0 auto;
}
</style>
